module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red@2x-c75d71673f80a605fcba155fb052b954.png";